export const SET_BREADCRUMB = 'SET_BREADCRUMB'

export const SET_USERINFO = 'SET_USERINFO'

export const SET_LOGIN = 'SET_LOGIN'
